import React, { useState } from 'react';
import { Button, Divider, Typography } from '@ui';
import { Card, Flex } from 'antd';
import TeamMember from '../TeamMember';
import MemberForm from './components/MemberForm';

const StaffAccounts = ({ staffAccounts }) => {
    const [isFormVisible, setIsFormVisible] = useState(false);

    const onCancel = () => {
        setIsFormVisible(false);
    };
    const onAddStaffAccount = () => {
        setIsFormVisible(true);
    };

    return (
        <Card data-e2e='team-management_staff-accounts_block'>
            <Flex justify='space-between' align='center'>
                <Typography.Title level={2}>Staff accounts</Typography.Title>
                <Button type='link' onClick={onAddStaffAccount} data-e2e='team-management_add-staff-account_btn'>
                    Add Staff Account
                </Button>
            </Flex>
            {isFormVisible ? (
                <React.Fragment>
                    <Divider margin='24px 0' />
                    <MemberForm onCancel={onCancel} />
                </React.Fragment>
            ) : null}
            {staffAccounts.length ? (
                <React.Fragment>
                    <Divider margin='24px 0' />
                    <Flex vertical gap={24}>
                        {staffAccounts.map((member) => {
                            return <TeamMember key={member.id} member={member} />;
                        })}
                    </Flex>
                </React.Fragment>
            ) : null}
        </Card>
    );
};

export default StaffAccounts;
